import { PreviewPopupVisibleType } from '../typings/bannerCreativePreviewPopupState';
import { BannerId } from '../typings/banners';
import { PcodeRenderData } from '../typings/pcode';

export const SET_CREATIVE_PREVIEW_POPUP_DATA = 'SET_CREATIVE_PREVIEW_POPUP_DATA';
export type SET_CREATIVE_PREVIEW_POPUP_DATA = typeof SET_CREATIVE_PREVIEW_POPUP_DATA;

export interface SetCreativePreviewPopupDataAction {
    type: SET_CREATIVE_PREVIEW_POPUP_DATA;
    bannerData: PcodeRenderData;
    creativeUrl?: string;
    id?: string;
    previewPopupVisibleType: PreviewPopupVisibleType;
}

export function setCreativePreviewPopupData(
    bannerData: PcodeRenderData,
    previewPopupVisibleType: PreviewPopupVisibleType,
    creativeUrl?: string,
    id?: string
): SetCreativePreviewPopupDataAction {
    return {
        type: SET_CREATIVE_PREVIEW_POPUP_DATA,
        bannerData,
        creativeUrl,
        previewPopupVisibleType,
        id
    };
}

export const CLICK_PREVIEW_LINK = 'CLICK_PREVIEW_LINK';
export type CLICK_PREVIEW_LINK = typeof CLICK_PREVIEW_LINK;

export interface ClickPreviewLink {
    type: CLICK_PREVIEW_LINK;
}

export function clickPreviewLink(): ClickPreviewLink {
    return {
        type: CLICK_PREVIEW_LINK
    };
}

export const CLOSE_CREATIVE_PREVIEW_POPUP = 'CLOSE_CREATIVE_PREVIEW_POPUP';
export type CLOSE_CREATIVE_PREVIEW_POPUP = typeof CLOSE_CREATIVE_PREVIEW_POPUP;

export interface CloseCreativePreviewPopupAction {
    type: CLOSE_CREATIVE_PREVIEW_POPUP;
}

export function closeCreativePreviewPopup(): CloseCreativePreviewPopupAction {
    return {
        type: CLOSE_CREATIVE_PREVIEW_POPUP
    };
}

export const UPDATE_PCODE_PREVIEW_CREATIVE_POPUP = 'UPDATE_PCODE_PREVIEW_CREATIVE_POPUP';
export type UPDATE_PCODE_PREVIEW_CREATIVE_POPUP = typeof UPDATE_PCODE_PREVIEW_CREATIVE_POPUP;

export interface UpdatePcodePreviewPopup {
    type: UPDATE_PCODE_PREVIEW_CREATIVE_POPUP;
    adId: BannerId;
}

export function updatePcodePreviewPopup(adId: BannerId): UpdatePcodePreviewPopup {
    return {
        type: UPDATE_PCODE_PREVIEW_CREATIVE_POPUP,
        adId
    };
}

export type BannerCreativePreviewPopupAction =
    | SetCreativePreviewPopupDataAction
    | CloseCreativePreviewPopupAction
    | UpdatePcodePreviewPopup
    | ClickPreviewLink;
